import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5cb560ce")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["checkbox-container flex items-center", _ctx.classList]
  }, [
    (_ctx.checkedData)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("input", {
            id: _ctx.label,
            checked: _ctx.checkedData,
            type: "checkbox",
            value: _ctx.label
          }, null, 8, ["id", "checked", "value"]),
          (_ctx.label)
            ? (_openBlock(), _createBlock("label", {
                key: 0,
                for: _ctx.label
              }, _toDisplayString(_ctx.$t(_ctx.label)), 9, ["for"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("input", {
            id: _ctx.label,
            checked: _ctx.value,
            type: "checkbox",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateValue($event.target.checked)))
          }, null, 40, ["id", "checked"]),
          (_ctx.label)
            ? (_openBlock(), _createBlock("label", {
                key: 0,
                for: _ctx.label
              }, _toDisplayString(_ctx.$t(_ctx.label)), 9, ["for"]))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
})